export const BreadcrumbItemType = {
    START: -1,
    AGENDATYPE: 0, 
    YEAR: 1,
    AGENDA: 2,
    AGENDAITEM: 3,
    DOCUMENT: 4
}